<template>
<div class="container">
    <div class="row d-flex mb-4 justify-content-end">
        <div class="col-8">
            <h3 class="c-ndarkthree bold d-flex align-items-center">
                <CircleSuccess :color="getPrimaryColorHex.four" class="mr-2"/> Parceiros
            </h3>
            <p class="c-ndarkfour">
                Visualize todos os parceiros white label da plataforma.
            </p>
        </div>
        <div class="col-4 d-flex align-items-end justify-content-end">
            <Button @click="newPartner()" :color="getPrimaryColor">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.99983 1V9M1 5H8.99967" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Novo parceiro
            </Button>
        </div>
        <div class="col-12 mt-4 pt-3 d-flex align-items-center justify-content-end">
            <div class="ml-2">
                <el-input v-model="filter" @keyup.native.enter="filterPartners" placeholder="Buscar" :class="`${getPrimaryColor} filter`" clearable>
                    <button class="btn" slot="append" @click="filterPartners">
                        <SearchIcon class="mx-0" size="16" />
                    </button>
                </el-input>
                <h6 slot="append" class="regular">
                    Busque pelo nome do parceiro. Ex.: <span :class="`c-${getPrimaryColor}four`"> Uni Impacta. </span>
                </h6>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <TableLoading v-if="isLoading" rowHeight="56" class="mt-3"/>
            <Partners v-else-if="partnersData.length" :tableData="partnersData"/>
            <NotFound v-else-if="notFound"/>
            <Empty
                title="Nenhum parceiro associado!"
                v-else
            >
                Por enquanto, não há parceiros associados.
            </Empty>
        </div>
    </div>
    <FullLoading :color="getPrimaryColorHex.five" v-if="$store.state.user.loading"/>
</div>
</template>

<script>

//ICONS:
import CircleSuccess from '@/components/icons/CircleSuccess' 

//COMPONENTS
import Partners from '@/components/tables/Partners'
import NotFound from '@/components/emptyOrNotFound/NotFound'
import Empty from '@/components/emptyOrNotFound/EmptyEconomicGroup'
import FullLoading from '@/components/loading/FullLoading'
import TableLoading from '@/components/loading/TableLoading'

//API
import getSponsorPartners from '@/api/getSponsorPartners'

export default {
    components: {
        Partners,
        CircleSuccess,
        NotFound,
        FullLoading,
        TableLoading,
        Empty,
    },
    data() {
        return {
            isLoading: false,
            partnersData: [],
            filter: '',
        }
    },
    watch: {
        filter(val) {
            if (!val.length) {
                this.getAllPartners()
            }
        }
    },
    methods: {
        async getAllPartners() {
            this.isLoading = true

            const partners = await getSponsorPartners()
            this.partnersData = partners

            this.isLoading = false
        },
        async filterPartners() {
            this.isLoading = true

            const partners = await getSponsorPartners(this.filter)
            if(partners.length) {
                this.notFound = false
                this.partnersData = partners
            } else {
                this.notFound = true
                this.partnersData = []
            }

            this.isLoading = false
        },
        newPartner() {
            this.$router.push('/partners/new')
        }
    },
    created() {
        this.getAllPartners()
    }
}
</script>

<style lang="scss" scoped>
</style>
